import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './lang/i18n';
import './assets/scss/common.scss';
import './assets/scss/media.scss';
import Validate from './plugins/validate';
import Scroller from './lib/scroller';
import Helper from './lib/helper';
import Card from './components/ui/Card';
import CardForm from './components/ui/CardForm';
import VueTextareaAutosize from 'vue-textarea-autosize';
import {format} from "date-fns";
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.config.productionTip = false;

Vue.use(Validate, {
  i18n,
  events: 'change'
});

Vue.use(Scroller);
Vue.use(Helper);
Vue.use(VueTextareaAutosize);

Vue.component('card', Card);
Vue.component('card-form', CardForm);

Vue.filter('numFormat', numFormat(numeral));
Vue.filter('dateTime', (value) => format(new Date(value), 'yyyy-MM-dd HH:mm:ss'));
Vue.filter('date', (value) => format(new Date(value), 'yyyy-MM-dd'));

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL}sw.js`).catch(error => {
      console.warn('Service worker registration failed:', error);
    });
  });
}
